<template>
    <div class="main-page">
        <aside class="sidebar-wrap" id="sidebarManu" :class="{ active: status }">
            <div class="img-logo">
                <img src="@/assets/abi-vertical.png" alt="" />
            </div>
            <Sidebar v-if="checkRole == 5 || checkRole == 3 || checkRole == 7" />
            <SidebarAdmin v-if="checkRole == 6 || checkRole == 2" />
        </aside>

        <section class="dashboard">
            <header class="header" v-if="widthScreen < 760">
                <div class="humberger-icon" @click="openToggle">
                    <label class="sidebarIconToggle">
                        <div class="spinner diagonal part-1" :class="{ diagonaltop: status }"></div>
                        <div class="spinner horizontal" :class="{ centerLine: status }"></div>
                        <div class="spinner diagonal part-2" :class="{ diagonalbottom: status }"></div>
                    </label>
                </div>
            </header>
            <main>
                <router-view></router-view>
            </main>
            <footer class="footer">
                <span>ABI Commodity Future</span>
                <div class="contact">
                    <div>
                        <img src="../assets/call-answer.png" alt="telepone" />
                        <span>+6221 5761461</span>
                    </div>
                    <div>
                        <img src="../assets/message-closed-envelope.png" alt="email" />
                        <span>info@abicommodity.co.id</span>
                    </div>
                </div>
            </footer>
        </section>
    </div>
</template>

<script>
import Sidebar from "../components/Sidebar.vue";
import SidebarAdmin from "../components/admin/SidebarAdmin";
// import DropdownContent from "../components/dropdown/DropdownContent.vue";
// import Dropdown from "../components/dropdown/Dropdown.vue";

export default {
    components: {
        Sidebar,
        SidebarAdmin,

        // DropdownContent,
        // Dropdown,
    },
    data() {
        return {
            status: false,
            nickname: localStorage.getItem("user"),
            widthScreen: "",
        };
    },
    mounted() {
        this.widthScreen = screen.width;
    },
    computed: {
        checkRole() {
            let role = localStorage.getItem("role");
            if (role) {
                return role;
            } else {
                return null;
            }
        },
    },

    methods: {
        openToggle() {
            this.status = !this.status;
        },
    },
};
</script>

<style scoped>
.main-page {
    display: flex;
    align-items: stretch;
    /* height: 100%; */
    min-height: 100vh;
    background: #f8f9fa;
}
.dashboard {
    width: 100%;
    margin-left: 219px;
}

.sidebar-wrap {
    width: 219px;
    box-shadow: 0 0 2rem 0 rgb(136 152 170 / 15%);
    background-color: #fff;
    position: fixed;
    height: 100vh;
    z-index: 1;
}

.humberger-icon {
    display: none;
}

main {
    padding: 2rem;
    height: 100%;
}

.header {
    margin-bottom: 0.7rem;
    display: block;
}

.profile img {
    width: 1.5rem;
}

.img-logo {
    height: 6rem;
    padding: 20px 0;
    text-align: center;
}

.img-logo img {
    height: 100%;
}

.footer {
    background: #1e354a;
    color: white;
    padding: 1rem 2rem;
    display: flex;
    justify-content: space-between;
    margin-top: auto;
    align-items: center;
}

.footer span {
    font-size: 14px;
    flex: 2;
}

.footer .contact {
    display: flex;
    justify-content: space-between;
    gap: 2rem;
}

.footer .contact img {
    width: 20px;
    margin-right: 11px;
}

.footer .contact span {
    font-size: 12px;
}

.sidebarIconToggle {
    transition: all 0.3s;
    box-sizing: border-box;
    cursor: pointer;
    position: absolute;
    z-index: 99;
    height: 100%;
    width: 100%;
    height: 22px;
    width: 22px;
}
.spinner {
    transition: all 0.3s;
    box-sizing: border-box;
    position: absolute;
    height: 3px;
    width: 100%;
    background-color: #6454f0;
}

.horizontal {
    transition: all 0.3s;
    box-sizing: border-box;
    position: relative;
    float: left;
    margin-top: 3px;
}
.diagonal.part-1 {
    position: relative;
    transition: all 0.3s;
    box-sizing: border-box;
    float: left;
}
.diagonal.part-2 {
    transition: all 0.3s;
    box-sizing: border-box;
    position: relative;
    float: left;
    margin-top: 3px;
}

input[type="checkbox"] {
    transition: all 0.3s;
    box-sizing: border-box;
    display: none;
}

/* input[type=checkbox]:checked ~  */
.sidebarIconToggle > .centerLine {
    transition: all 0.3s;
    box-sizing: border-box;
    opacity: 0;
}
/* input[type=checkbox]:checked ~  */
.sidebarIconToggle > .diagonaltop {
    transition: all 0.3s;
    box-sizing: border-box;
    transform: rotate(135deg);
    margin-top: 8px;
}
/* input[type=checkbox]:checked ~  */
.sidebarIconToggle > .diagonalbottom {
    transition: all 0.3s;
    box-sizing: border-box;
    transform: rotate(-135deg);
    margin-top: -9px;
}

ul {
    list-style: none;
    margin: unset;
}

ul li {
    padding: 0.5rem 0;
}

hr {
    margin: 0.3rem 0;
}

.content-dropdown {
    right: 1rem;
}

@media (max-width: 768px) {
    .humberger-icon {
        display: block;
        position: absolute;
        right: 1.2rem;
        top: 1.8rem;
        height: 22px;
        width: 22px;
    }

    .sidebar-wrap {
        display: none;
        /* transform: translateX(-264px); */
        -webkit-transition: transform 0.8s linear;
        -moz-transition: transform 0.8s linear;
        -o-transition: transform 0.8s linear;
        -ms-transition: transform 0.8s linear;
        transition: transform 0.8s linear;
        animation: slide-right 0.4s linear;
    }

    .active {
        /* transform: translateX(0); */
        z-index: 1;
        display: block;
        width: 18rem;
        -webkit-transition: transform 0.8s linear;
        -moz-transition: transform 0.8s linear;
        -o-transition: transform 0.8s linear;
        -ms-transition: transform 0.8s linear;
        transition: transform 0.8s linear;
        animation: slide-right 0.4s linear;
    }

    .dashboard {
        margin-left: unset;
    }

    main {
        padding: 0.6rem 1.3rem;
    }

    .footer {
        padding: 1rem;
    }

    .footer .contact {
        flex-direction: column;
        gap: unset;
    }

    .img-logo {
        height: 4rem;
        padding: 0.5rem 0;
    }

    @keyframes slide-right {
        from {
            opacity: 0;
            transform: translateX(-264px);
        }
        to {
            opacity: 1;
            transform: translateX(0);
        }
    }
}
</style>
